import {
  Success,
  TipsSolid,
  Warning,
  Error,
  Close,
  Loading,
  CircleCheck,
  CircleClose,
  Question,
} from '@sgui-plus/icons-vue'
import { definePropType } from './props'
import type { Component } from 'vue'

export const iconPropType = definePropType<string | Component>([String, Object])

export const TypeComponents = {
  Close,
  Success,
  TipsSolid,
  Warning,
  Error,
}

export const TypeComponentsMap = {
  primary: TipsSolid,
  success: Success,
  warning: Warning,
  error: Error,
  info: TipsSolid,
  confirm: Question
}

export const ValidateComponentsMap = {
  validating: Loading,
  success: CircleCheck,
  error: CircleClose,
}
